import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomeRoutingModule } from './home-routing.module';

import { LibrariesModule } from '../../common/libraries/libraries.module';
import { RouterModule, RouterOutlet } from '@angular/router';
import { HeaderTopModule } from '../../common/components/header-top/header-top.module';
import { HeaderModule } from '../../common/components/header/header.module';
import { FooterModule } from '../../common/components/footer/footer.module';
import { HomeComponent } from './home.component';
import { SharedModule } from '../../common/shared/shared.module';



@NgModule({
    declarations: [HomeComponent],
    exports: [HomeComponent],
    imports: [
        CommonModule,
        HomeRoutingModule,
        LibrariesModule,
        RouterOutlet,
        HeaderTopModule,
        HeaderModule,
        FooterModule,
        RouterModule,
        SharedModule,
    ]
})
export class HomeModule { }
